module.exports = __webpack_public_path__ + "static/img/Kyra-Cooney-Cross.825144e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kyra-Cooney-Cross.jpg
// module id = ZAQz
// module chunks = 0